import type { PdfSectionScope } from "@repo/shared/types";
import { ProductCostsSourceSelect } from "@/components/product-costs-source-select";
import { useUserLanguage } from "@/lib/i18n/context";
import { useT } from "@/lib/i18n/use-t";
import type { ProductCostsComponentConfig } from "../types";
import { T } from "./product-costs-form.i18n";
import { TitleOnlyForm } from "./title-only-form";
import type { ComponentFormProps } from "./types";

type ProductCostsFormProps = ComponentFormProps<ProductCostsComponentConfig> & {
  componentDescription?: string;
  sectionScope?: PdfSectionScope;
};

/** QL-417 — title/description plus which portfolio the cost table describes. */
export function ProductCostsForm(props: ProductCostsFormProps) {
  const { config, onChange, sectionScope } = props;
  const { userLanguage } = useUserLanguage();
  const t = useT(T);

  return (
    <div className="space-y-4">
      <TitleOnlyForm {...props} onChange={(next) => onChange({ ...config, ...next })} />
      {/* Only a per-portfolio section has an existing portfolio to describe.
          Elsewhere the block always renders the new one, so offering the choice
          would be a setting that does nothing. Mirrors the flow-side gate. */}
      {sectionScope === "per_portfolio" && (
        <ProductCostsSourceSelect
          language={userLanguage}
          value={config.portfolioSource}
          onChange={(portfolioSource) => onChange({ ...config, portfolioSource })}
          hint={t.portfolioSourceHelp}
        />
      )}
    </div>
  );
}
